/* ==========================================================
   SARATTI GRB v88 — single sticky CTA owner
   Backup theme only.
   Purpose:
   - Stop CTA flicker caused by older scripts writing different labels.
   - Keep one source of truth for the floating bar button.
   - Does NOT touch Shopify variants or Metal Type rendering.
   ========================================================== */
(function () {
  'use strict';

  if (window.__SARATTI_STICKY_OWNER_V88__) return;
  window.__SARATTI_STICKY_OWNER_V88__ = true;

  var nativeTextContent = Object.getOwnPropertyDescriptor(Node.prototype, 'textContent');

  function qs(sel, root) { return (root || document).querySelector(sel); }
  function clean(el) { return el ? String(el.textContent || '').replace(/\s+/g, ' ').trim() : ''; }

  function stage() {
    var active = qs('.grb__panel--active');
    if (active && active.id === 'grb-panel-2') return 2;
    if (active && active.id === 'grb-panel-1') return 1;
    if (qs('#grb-panel-2.grb__panel--active')) return 2;
    if (qs('#grb-panel-1.grb__panel--active')) return 1;
    return 0;
  }

  function hasRingSize() {
    var select = qs('#grb-size-select');
    if (select && String(select.value || '').trim()) return true;
    var value = clean(qs('#grb-sum-size'));
    return !!(value && !/not selected|select|ring size/i.test(value));
  }

  function desiredLabel() {
    var s = stage();
    if (s === 0) return 'Build a piece';
    if (s === 1) return 'Finalise';
    return hasRingSize() ? 'Add both to cart' : 'Select ring size';
  }

  function setNativeText(btn, value) {
    if (!btn) return;
    try { nativeTextContent.set.call(btn, value); } catch (e) { btn.innerText = value; }
  }

  function ownButton(btn) {
    if (!btn || btn.dataset.sarattiStickyOwnerV88 === 'true') return;
    btn.dataset.sarattiStickyOwnerV88 = 'true';
    try {
      Object.defineProperty(btn, 'textContent', {
        configurable: true,
        get: function () { return desiredLabel(); },
        set: function () { setNativeText(btn, desiredLabel()); }
      });
    } catch (e) {}
  }

  function syncButton(btn) {
    if (!btn) return;
    ownButton(btn);
    var label = desiredLabel();
    if (clean(btn) !== label) setNativeText(btn, label);
    btn.disabled = false;
    btn.removeAttribute('data-grb-v85-size-gate');
    btn.removeAttribute('data-saratti-stage-action-v86');
    btn.removeAttribute('data-saratti-stage-action-v87');
    btn.setAttribute('data-saratti-stage-action-v88', String(stage()));
    btn.classList.toggle('grb-v85-size-missing', stage() === 2 && !hasRingSize());
  }

  function syncAll() {
    syncButton(qs('#grb-sticky-btn'));
    syncButton(qs('#grb-sbar-btn'));

    var cartBtn = qs('#grb-cart-btn');
    if (cartBtn) {
      cartBtn.disabled = false;
      if (stage() === 2 && !hasRingSize()) {
        cartBtn.textContent = 'Select ring size to continue';
        cartBtn.setAttribute('data-saratti-stage-action-v88', '2');
      }
    }
  }

  function focusRingSize() {
    var select = qs('#grb-size-select');
    if (!select) return;
    select.classList.add('grb__field--error');
    select.setAttribute('aria-invalid', 'true');
    var wrap = select.closest('.grb__config-row') || select;
    if (wrap.scrollIntoView) wrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
    setTimeout(function () {
      try { select.focus({ preventScroll: true }); } catch (e) { try { select.focus(); } catch (_) {} }
    }, 240);
  }

  function handleAction(event) {
    var btn = event.target && event.target.closest ? event.target.closest('[data-saratti-stage-action-v88], #grb-sticky-btn, #grb-sbar-btn') : null;
    if (!btn || !window.GRB) return;

    var s = stage();
    event.preventDefault();
    event.stopPropagation();

    if (s === 0 && typeof window.GRB.goTab === 'function') {
      window.GRB.goTab(1);
      requestSync();
      return;
    }

    if (s === 1 && typeof window.GRB.goTab === 'function') {
      window.GRB.goTab(2);
      requestSync();
      return;
    }

    if (s === 2 && !hasRingSize()) {
      focusRingSize();
      requestSync();
      return;
    }

    if (s === 2 && typeof window.GRB.addToCart === 'function') {
      window.GRB.addToCart();
      requestSync();
    }
  }

  function requestSync() {
    syncAll();
    setTimeout(syncAll, 20);
    setTimeout(syncAll, 90);
    setTimeout(syncAll, 240);
  }

  function installCss() {
    if (document.getElementById('saratti-sticky-owner-v88-style')) return;
    var css = '' +
      '@media screen and (min-width:990px){#grb #grb-stickybar.grb__stickybar{left:38vw!important;right:38vw!important;width:auto!important;max-width:none!important;transform:translateY(18px)!important;grid-template-columns:52px minmax(0,1fr) auto auto!important;}#grb #grb-stickybar.grb__stickybar.grb__stickybar--visible,#grb #grb-stickybar.grb__stickybar.grb-scroll-paused-v71{transform:translateY(0)!important;}}' +
      '@media screen and (min-width:750px) and (max-width:989px){#grb #grb-stickybar.grb__stickybar{left:34vw!important;right:34vw!important;width:auto!important;max-width:none!important;transform:translateY(18px)!important;grid-template-columns:52px minmax(0,1fr) auto!important;}#grb #grb-stickybar.grb__stickybar.grb__stickybar--visible,#grb #grb-stickybar.grb__stickybar.grb-scroll-paused-v71{transform:translateY(0)!important;}}' +
      '@media screen and (max-width:749px){#grb #grb-stickybar.grb__stickybar{left:34vw!important;right:34vw!important;width:auto!important;max-width:none!important;transform:translateY(18px)!important;grid-template-columns:minmax(0,1fr)!important;}#grb #grb-stickybar.grb__stickybar.grb__stickybar--visible,#grb #grb-stickybar.grb__stickybar.grb-scroll-paused-v71{transform:translateY(0)!important;}#grb #grb-stickybar .grb__sticky-thumb,#grb #grb-stickybar .grb__sticky-copy,#grb #grb-stickybar .grb__sticky-price{display:none!important;}}' +
      '#grb .grb__own-design-wide-v55{grid-template-columns:minmax(220px,42%) minmax(0,1fr)!important;max-width:100%!important;overflow:hidden!important;}' +
      '#grb .grb__own-design-copy-v55{box-sizing:border-box!important;min-width:0!important;width:100%!important;padding:34px clamp(24px,4vw,56px)!important;overflow:hidden!important;}' +
      '#grb .grb__own-design-copy-v55 strong{display:block!important;max-width:100%!important;white-space:normal!important;overflow:visible!important;text-overflow:clip!important;font-size:clamp(30px,3vw,46px)!important;line-height:1.05!important;}' +
      '@media screen and (max-width:989px){#grb .grb__own-design-wide-v55{grid-template-columns:1fr!important;}#grb .grb__own-design-copy-v55{padding:28px 24px!important;}}';
    var style = document.createElement('style');
    style.id = 'saratti-sticky-owner-v88-style';
    style.textContent = css;
    document.head.appendChild(style);
  }

  function silenceDuplicateAlert() {
    if (window.__SARATTI_DUPLICATE_ALERT_PATCHED_V88__) return;
    window.__SARATTI_DUPLICATE_ALERT_PATCHED_V88__ = true;
    var originalAlert = window.alert;
    window.alert = function (message) {
      var msg = String(message || '');
      if (/maximum quantity/i.test(msg) && /already in your cart/i.test(msg)) return;
      return originalAlert.apply(window, arguments);
    };
  }

  function boot() {
    installCss();
    silenceDuplicateAlert();
    requestSync();
  }

  document.addEventListener('click', function (event) {
    handleAction(event);
    requestSync();
  }, true);
  document.addEventListener('change', requestSync, true);
  document.addEventListener('input', requestSync, true);

  var observerTimer = null;
  new MutationObserver(function () {
    clearTimeout(observerTimer);
    observerTimer = setTimeout(syncAll, 10);
  }).observe(document.documentElement, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class', 'disabled', 'data-grb-v85-size-gate'] });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  window.addEventListener('load', boot);
})();
